import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  panelContent: {
    height: '96vh',
    padding: '24px 8px 24px 24px',
  },
  closeIconButton: {
    padding: theme.spacing(0.5),
    position: 'absolute',
    marginTop: theme.spacing(1),
    right: theme.spacing(1),
    opacity: 0.6,
    color: theme.evPalette.charcoal[900],
    '&:hover': {
      opacity: 1,
    },
  },
  anomalyCardsScroll: {
    maxHeight: '90vh',
    overflowY: 'auto',
    paddingRight: theme.spacing(1),
  },
  anomalyCardsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    overflowY: 'auto',
    maxHeight: '88vh',
  },
  anomalyCard: {
    flex: '1 1 240px',
    minWidth: '240px',
  },
}));
